import store from '@/store';
import { ITournamentFreeSpin, TournamentFreeSpin } from '../defaultObjects';
import { Utils } from '@/utils/Utils';
import { ActionContext } from 'vuex';

type State = {
  isPopupWinFreeSpin: boolean;
  isPopupFinishFreeSpin: boolean;
  isPopupWinFreeSpinOtherGame: boolean;
  isPopupWinPrizeGame: boolean;
  totalWin: string | null;
  tournamentFreeSpin: ITournamentFreeSpin;
};

export default {
  state: {
    isPopupWinFreeSpin: false,
    isPopupFinishFreeSpin: false,
    isPopupWinFreeSpinOtherGame: false,
    isPopupWinPrizeGame: false,
    totalWin: null,
    tournamentFreeSpin: TournamentFreeSpin
  },
  getters: {
    isFreeSpinWInPopup(state: State, getters: any) {
      return (
        state.isPopupWinFreeSpin && (getters.isFreeRounds || getters.hasAchievement || getters.hasFreeSpinsTournament)
      );
    },
    isFreeSpinFinishPopup(state: State, getters: any) {
      return (
        state.isPopupFinishFreeSpin &&
        (getters.isFreeRounds || getters.hasAchievement || getters.hasFreeSpinsTournament)
      );
    },
    isFreeSpinWInOtherGamePopup(state: State, getters: any) {
      return state.isPopupWinFreeSpinOtherGame && (getters.hasAchievement || getters.hasFreeSpinsTournament);
    },
    isPrizeGameWinPopup(state: State, getters: any) {
      return state.isPopupWinPrizeGame && getters.hasAchievement;
    },

    getTotalWinFreeSpin(state: State) {
      return state.totalWin;
    },
    hasFreeSpinsTournament(state: State) {
      if (!state.tournamentFreeSpin) return false;

      return state.tournamentFreeSpin.denomination && state.tournamentFreeSpin.tournament;
    },
    getAmountLeftSpinsTournament(state: State) {
      if (!state.tournamentFreeSpin) return null;

      return state.tournamentFreeSpin.reward.roundsLeft;
    },
    getTournamentFreeSpinCurrency(state: State) {
      if (!state.tournamentFreeSpin) return '';

      return state.tournamentFreeSpin.currency;
    },
    getTournamentFreeSpinGameName(state: State) {
      if (!state.tournamentFreeSpin) return '';

      return state.tournamentFreeSpin.reward.gameName;
    },
    getRewardTournament(state: State) {
      if (!state.tournamentFreeSpin) return {};
      return state.tournamentFreeSpin.reward;
    },
    isTournamentFreeSpinGame(state: State) {
      if (!state.tournamentFreeSpin) return false;

      return state.tournamentFreeSpin.reward.roundsLeft !== null;
    },
    getLinkGameTournament(state: State) {
      if (!state.tournamentFreeSpin || !state.tournamentFreeSpin.reward.linkGame) return null;

      return state.tournamentFreeSpin.reward.linkGame;
    },
    getAchievementTournament(state: State) {
      return state.tournamentFreeSpin;
    }
  },
  mutations: {
    showFreeSpinWin(state: State) {
      state.isPopupWinFreeSpin = true;
    },
    hideFreeSpinWin(state: State) {
      state.isPopupWinFreeSpin = false;
    },
    showFreeSpinFinish(state: State, data: { totalWin: string } | undefined) {
      state.isPopupFinishFreeSpin = true;
      if (!data) return;
      state.totalWin = data.totalWin;
    },
    hideFreeSpinFinish(state: State) {
      state.isPopupFinishFreeSpin = false;
      state.tournamentFreeSpin = TournamentFreeSpin;
      state.totalWin = null;
    },
    showFreeSpinWinOtherGame(state: State) {
      state.isPopupWinFreeSpinOtherGame = true;
    },
    hideFreeSpinWinOtherGame(state: State) {
      state.isPopupWinFreeSpinOtherGame = false;
    },
    setFreeSpinData(
      state: State,
      {
        tournamentFreeSpin,
        currency,
        currencyDecimal
      }: { tournamentFreeSpin: ITournamentFreeSpin; currency: string; currencyDecimal: number }
    ) {
      state.tournamentFreeSpin = JSON.parse(JSON.stringify(tournamentFreeSpin));
      state.tournamentFreeSpin.currency = currency;
      state.tournamentFreeSpin.currencyDecimal = currencyDecimal;

      const rewardFreeSpins = state.tournamentFreeSpin.reward;
      const { wins } = rewardFreeSpins;

      if (wins) {
        // const cent = Number(Number(wins).toFixed(2));
        const cent = Number(wins);
        rewardFreeSpins.wins = Utils.centsToMoneyStr(
          cent,
          state.tournamentFreeSpin.currencyDecimal,
          state.tournamentFreeSpin.currency
        );
      }
    },
    showPrizeGameWin(state: State) {
      state.isPopupWinPrizeGame = true;
    },
    hidePrizeGameWin(state: State) {
      state.isPopupWinPrizeGame = false;
    }
  },
  actions: {
    SHOW_FREESPIN_WIN({ commit }: ActionContext<any, any>) {
      commit('showFreeSpinWin');
    },
    HIDE_FREESPIN_WIN({ commit }: ActionContext<any, any>) {
      commit('hideFreeSpinWin');
    },
    SHOW_FREESPIN_FINISH({ commit }: ActionContext<any, any>, data: { totalWin: string } | undefined) {
      commit('showFreeSpinFinish', data);
    },
    HIDE_FREESPIN_FINISH({ commit }: ActionContext<any, any>) {
      commit('hideFreeSpinFinish');
      // нужно для кейса, когда фриспины по каунтеру закончились, но фрираунды ещё есть
      if (store.getters.isFreeRounds && !store.getters.getAmountLeftSpinsFreeRounds) {
        store.dispatch('CLEAR_FREE_ROUNDS');
        return;
      }
      store.dispatch('CLEAR_ACHIEVEMENT');
    },
    SHOW_FREESPIN_WIN_OTHER_GAME({ commit }: ActionContext<any, any>) {
      commit('showFreeSpinWinOtherGame');
      commit('hideProgressBar');
    },
    HIDE_FREESPIN_WIN_OTHER_GAME({ commit }: ActionContext<any, any>) {
      commit('hideFreeSpinWinOtherGame');
    },
    SET_FREESPIN_DATA(
      { commit }: ActionContext<any, any>,
      data: { tournamentFreeSpin: ITournamentFreeSpin; currency: string; currencyDecimal: number }
    ) {
      commit('setFreeSpinData', data);
    },
    SHOW_PRIZE_GAME_WIN({ commit }: ActionContext<any, any>) {
      commit('showPrizeGameWin');
    },
    HIDE_PRIZE_GAME_WIN({ commit }: ActionContext<any, any>) {
      commit('hidePrizeGameWin');
    }
  }
};
